import * as actionTypes from "./SalesQuoteType";

const INITIAL_STATE = {
    salesQuoteList: [],
    quoteNoList: [],
    filterCustomerList: [],
    items: [],
    itemList: [],
    customersList: [],
    taxList: [],
    warehouseList: [],
    costcenterList: [],
    paytermsList: [],
    supplyList: [],
    salesempList: [],
    salesQuote: null,
    customerAddress: [],
    customerAddressList: [],
    prjList: [],
    seriesList: [],
    hsnList: [],
    attachmentList: [],
    advanceFilterList: [],
    itemInfo: null,
    customerInfo: [],
    duplicateDoc: null,
    defaultCurrency: null,
    kitItem: null,
    udfList: [],
    emailContent: null,
    flexiQuote: null,
    basicFilterData: []
};

const SalesQuoteReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETQUOTENOLIST:
            return {
                ...state,
                quoteNoList: action.payload.list,
            };
        case actionTypes.SETFILTERCUSTOMERLIST:
            return {
                ...state,
                filterCustomerList: action.payload.list,
            };
        case actionTypes.SETSALESQUOTELIST:
            return {
                ...state,
                salesQuoteList: action.payload.list,
            };
        case actionTypes.SETITEMS:
            return {
                ...state,
                items: action.payload.list,
            };
        case actionTypes.SETCUSTOMERLIST:
            return {
                ...state,
                customersList: action.payload.list,
            };
        case actionTypes.SETPAYTERMSLIST:
            return {
                ...state,
                paytermsList: action.payload.list,
            };
        case actionTypes.SETSUPPLYLIST:
            return {
                ...state,
                supplyList: action.payload.list,
            };
        case actionTypes.SETSALESEMPLIST:
            return {
                ...state,
                salesempList: action.payload.list,
            };
        case actionTypes.SETCUSTOMERADDRESS:
            return {
                ...state,
                customerAddress: action.payload.list,
            };
        case actionTypes.SETCUSTOMERADDRESSLIST:
            return {
                ...state,
                customerAddressList: action.payload.list,
            };
        case actionTypes.SETWHSELIST:
            return {
                ...state,
                warehouseList: action.payload.list,
            };
        case actionTypes.SETPRJLIST:
            return {
                ...state,
                prjList: action.payload.list,
            };
        case actionTypes.SETTAXLIST:
            return {
                ...state,
                taxList: action.payload.list,
            };
        case actionTypes.SETCOSTCENTERLIST:
            return {
                ...state,
                costcenterList: action.payload.list,
            };
        case actionTypes.SETITEMLIST:
            return {
                ...state,
                itemList: action.payload,
            };
        case actionTypes.SETSERIESLIST:
            return {
                ...state,
                seriesList: action.payload.list,
            };
        case actionTypes.SETHSNLIST:
            return {
                ...state,
                hsnList: action.payload.list,
            };
        case actionTypes.SETSALESQUOTE:
            return {
                ...state,
                salesQuote: action.payload.data,
            };
        case actionTypes.CLEARDOC:
            return {
                ...state,
                salesQuote: null,
                itemList: [],
                customerAddress: [],
                customerAddressList: [],
                itemInfo: null,
                customerInfo: [],
                duplicateDoc: null,
                flexiQuote: null,
                kitItem: null
            };
        case actionTypes.SETATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list,
            };
        case actionTypes.SETADVANCEFILTERLIST:
            return {
                ...state,
                advanceFilterList: action.payload.list
            };
        case actionTypes.SETITEMINFO:
            return {
                ...state,
                itemInfo: action.payload.data
            };
        case actionTypes.SETCUSTOMERINFO:
            return {
                ...state,
                customerInfo: action.payload.data
            };
        case actionTypes.SETDUPLICATEDOC:
            return {
                ...state,
                duplicateDoc: action.payload.data
            }
        case actionTypes.SETDEFAULTCURRENCY:
            return {
                ...state,
                defaultCurrency: action.payload.data
            }
        case actionTypes.SETKITITEM:
            return {
                ...state,
                kitItem: action.payload.data
            }
        case actionTypes.SETUDFLIST:
            return {
                ...state,
                udfList: action.payload.list
            };
        case actionTypes.SETEMAILCONTENT:
            return {
                ...state,
                emailContent: action.payload.data
            };
        case actionTypes.SETFLEXIQUOTEDETAILS:
            return {
                ...state,
                flexiQuote: action.payload.data
            };
        case actionTypes.SETSALESQUOTEBASICFILTERDATA:
            return {
                ...state,
                basicFilterData: { ...action.payload }
            };
        default:
            return state;
    }
}

export default SalesQuoteReducer;